import { setCreateCampaignAudiencesSearchText } from '@/features/campaigns/campaignsSlice';
import { SearchInput } from '@/global/components';
import { RootState } from '@/reducers';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const AudienceTableSearch: FC = () => {
  const { t } = useTranslation();

  return (
    <SearchInput
      stateSelector={(state: RootState) => state.campaigns.create.audiences.searchText}
      stateUpdater={setCreateCampaignAudiencesSearchText}
      placeholder={t('COMMON:search')}
    />
  );
};
